// services
import { CAS } from "../../service/ChatConfig.Service";

//components
import { ProfileImage } from "thrive-components";

//interfaces
import { IContactButtonProps } from "../../interfaces";




const ContactButton = ({onClickContact, profileImageUrl, displayName, jobRole, department}: IContactButtonProps) => {
    
    return (
        <button
            onClick={onClickContact}
            type='button'
        >
            <div className="contact-image-wrapper">
                <ProfileImage 
                    className="contact-image" 
                    profileImageUrl={profileImageUrl}
                    accessToken={CAS.getAccessToken() as string}
                />
            </div>

            <div className="contact-information">
                <span className='contact-name'>
                    {displayName}
                </span>

                <span className='contact-details'>
                    {jobRole}
                    {jobRole && department && ', '}
                    {department}
                </span>
            </div>
        </button>
    );
};

export default ContactButton;